'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.useMergeState = undefined;

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _react = require('react');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var useMergeState = exports.useMergeState = function useMergeState(initialState) {
    var _useState = (0, _react.useState)(initialState),
        _useState2 = (0, _slicedToArray3.default)(_useState, 2),
        state = _useState2[0],
        setState = _useState2[1];

    var setMergedState = function setMergedState(newState) {
        return setState(function (prevState) {
            return (0, _assign2.default)({}, prevState, newState);
        });
    };
    return [state, setMergedState];
};